import React, { useEffect } from 'react';
import IconButton from '@material-ui/core/IconButton';
import Badge from '@material-ui/core/Badge';
import SmsIcon from '@material-ui/icons/Sms';
import messages, { MessageData } from '../../services/db/messages/messages';
import { makeStyles, Tooltip } from '@material-ui/core';
import MessageItem from './MessageItem';
import Popover from '@material-ui/core/Popover';
import List from '@material-ui/core/List';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Scrollbar from '../Scrollbar';
import IntlMessages from '../../utility/IntlMessages';
import Hidden from '@material-ui/core/Hidden';
import clsx from 'clsx';
import { Fonts } from '../../../shared/constants/AppEnums';
import { CremaTheme } from '../../../types/AppContextPropsType';
import { getUserToken } from '@crema/utility/AppHooks';
import { useGetTasksListQuery, useGetPatientToDoTaskListCountQuery } from 'generated/graphql';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import { useHistory } from 'react-router-dom';
import { formatAppointmentDateTime } from '../../../shared/utils/utcTime';

const useStyles = makeStyles((theme: CremaTheme) => ({
  crPopover: {
    '& .MuiPopover-paper': {
      width: 260,
      [theme.breakpoints.up('sm')]: {
        width: 300,
      },
      [theme.breakpoints.up('xl')]: {
        width: 380,
      },
    },
    '& .scroll-submenu': {
      maxHeight: 200,
      [theme.breakpoints.up('xl')]: {
        maxHeight: 380,
      },
    },
  },
  btnPopover: {
    borderRadius: 0,
    width: '100%',
    textTransform: 'capitalize',
  },
  notiBtn: {
    justifyContent: 'flex-start',
    width: '100%',
    height: 56,
    fontSize: 16,
    borderRadius: 0,
    paddingLeft: '1rem',
    paddingRight: '1rem',
    color: theme.palette.grey[800],
    '&:hover, &:focus': {
      color: theme.palette.text.primary,
      backgroundColor: 'transparent',
    },
    [theme.breakpoints.up('sm')]: {
      height: 70,
    },
    [theme.breakpoints.up('md')]: {
      justifyContent: 'center',
      width: 'auto',
      borderLeft: 'solid 1px',
      borderColor: theme.palette.grey[200],
      color: theme.palette.grey[400],
      '&:hover, &:focus': {
        color: theme.palette.text.primary,
        backgroundColor: 'rgba(0, 0, 0, 0.08)',
      },
    },
    [theme.breakpoints.up('lg')]: {
      paddingLeft: '1.5rem',
      paddingRight: '1.5rem',
    },
    [theme.breakpoints.up('xl')]: {
      paddingLeft: '2.5rem',
      paddingRight: '2.5rem',
    },
  },
  listStyle: {
    paddingLeft: 20,
    paddingRight: 20,
  },
  badgeStyle: {
    marginRight: 8,
    fontFamily: 'Roboto-Regular',
  },
  smsIcon: {
    fontSize: 22,
    color: theme.palette.text.secondary,
    [theme.breakpoints.up('xl')]: {
      fontSize: 30,
    },
  },
  listRoot: {
    paddingTop: 0,
    paddingBottom: 0,
  },
}));

interface HeaderMessagesProps { }

const HeaderMessages: React.FC<HeaderMessagesProps> = () => {
  const [
    anchorMessages,
    setAnchorMessages,
  ] = React.useState<HTMLButtonElement | null>(null);

  const history = useHistory();
  const onClickMessagesButton = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    setAnchorMessages(event.currentTarget);
  };

  const classes = useStyles();
  const token = getUserToken();
  const { data, loading, error } = useGetTasksListQuery({
    variables: { id: token },
  });
  const { data: dataCount, loading: loadingCount, error: errorCount } = useGetPatientToDoTaskListCountQuery({
    variables: { id: token },
  });
  const [taskData1, settaskData1] = React.useState([]);
  const [dataLoaded, setdataLoaded] = React.useState(false);
  const [taskCount, setTaskCount1] = React.useState([]);
  const [dataLoadedCount, setdataLoadedCount] = React.useState(false);

  // console.log(dataCount,"dataCount")
  if (!dataLoaded) {
    if (data === undefined) return null;
    else {
      let res: string = JSON.stringify(data);
      // console.log("task before:- ",res);
      settaskData1(JSON.parse(JSON.stringify(data?.PatientTaskList)));
    }
    setdataLoaded(true);
  }
  if (!dataLoadedCount) {
    if (dataCount === undefined) return null;
    else {
      let res: string = JSON.stringify(dataCount);
      // console.log("task before:- ",res);
      setTaskCount1(JSON.parse(JSON.stringify(dataCount?.PatientToDoTaskListCount?.taskList
      )));
    }
    setdataLoadedCount(true);
  }

  const handleRedirectTask = () => {
    history.push("/tasks")
    // window.location.href = "/tasks"

  }
  return (
    <>
      <Tooltip title={<IntlMessages id='header.tooltip.headerMessages' />}>
        <IconButton
          className={clsx(classes.notiBtn, 'notiBtn')}
          aria-label='show 4 new mails'
          color='inherit'
          onClick={onClickMessagesButton}>
          <Badge
            className={classes.badgeStyle}
            badgeContent={taskCount.length}
            color='secondary'
            overlap='rectangular'>
            <NotificationsActiveIcon className={clsx(classes.smsIcon, 'smsIcon')} />
          </Badge>
          <Hidden mdUp>
            <Box
              ml={4}
              fontSize={16}
              fontFamily='Roboto-Regular'
              fontWeight={Fonts.REGULAR}
              component='span'>
              <IntlMessages id='dashboard.messages' />
            </Box>
          </Hidden>
        </IconButton>
      </Tooltip>
      <Popover
        anchorEl={anchorMessages}
        id='app-message'
        className={classes.crPopover}
        open={Boolean(anchorMessages)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        onClose={() => setAnchorMessages(null)}>
        <Box>
          <Box px={5} py={3}>
            <Box component='h5' fontFamily='Roboto-Regular' fontSize={16}>
              <IntlMessages id='common.notifications' />{" "}<span className='numericTxt'>({taskCount.length})</span>
            </Box>
          </Box>
          <Scrollbar className='scroll-submenu'>
            <List
              className={classes.listRoot}
              onClick={() => {
                setAnchorMessages(null);
              }}>
              {taskCount.map((item: any, index) => (

                <Box pl={{ xs: 4 }} pr={{ xs: 4 }} pb={{ xs: 2 }} component='p' color='text.secondary' key={index}>
                  {item?.appointmentDateTiming
                    ? (item?.message || '').replace(
                        '{apptTime}',
                        formatAppointmentDateTime(item.appointmentDateTiming, null, null, 'DD-MM-YYYY hh:mm A'),
                      )
                    : item?.message}
                </Box>
              ))}
            </List>
          </Scrollbar>
          <Box mt={2}>
            <Button
              className={classes.btnPopover}
              variant='contained'
              color='primary'
              onClick={handleRedirectTask}>
              <IntlMessages id='common.viewAll' />
            </Button>
          </Box>
        </Box>
      </Popover>
    </>
  );
};

export default HeaderMessages;
